import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RWS from 'reconnecting-websocket';
import ShareDB from 'sharedb/lib/client';
import SafeAppCloseHelper from '../helpers/SafeAppCloseHelper';
ShareDB.types.register(require('rich-text').type);
ShareDB.types.register(require('ot-json1').type);
export var CollabConnectionContext = React.createContext({
  connection: null
});

var log = function log(message) {
  return console.debug("CollabConnectionProvider - ".concat(message));
};

var TIMEOUT = 10000;
/* 10s */

var HEARTBEAT_INTERVAL = 10000;
/* 10s */

var SOCKET_OPTIONS = {
  debug: true,
  reconnectionDelayGrowFactor: 3
  /* Factor multiplying minReconnectionDelay at each connection attempt */
  ,
  minReconnectionDelay: 50
  /* 50ms - Delay impacts first connect and first connection reattempt */
  ,
  maxReconnectionDelay: 3000
  /* 3s - Max interval between two connection attempt */
  ,
  connectionTimeout: TIMEOUT
};
var ACCEPTABLE_RECONNECTION_DELAY = 5000;
/* 5s */

var CollabConnectionProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(CollabConnectionProvider, _Component);

  function CollabConnectionProvider(props) {
    var _this;

    _classCallCheck(this, CollabConnectionProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CollabConnectionProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getCollabUrl", function () {
      var _this$props = _this.props,
          collabEndpoint = _this$props.collabEndpoint,
          apiToken = _this$props.apiToken;
      return collabEndpoint + (apiToken ? "?apiToken=".concat(apiToken) : '');
    });

    _defineProperty(_assertThisInitialized(_this), "onSocketHeartbeat", function () {
      _this.socket.send('{"a":"ping"}');

      _this.heartbeatTimeout = setTimeout(_this.onSocketHeartbeatTimeout, TIMEOUT);
    });

    _defineProperty(_assertThisInitialized(_this), "onSocketHeartbeatTimeout", function () {
      _this.socket.reconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "onSocketOpened", function () {
      log('Socket opened');
      _this.pingTimeout = setTimeout(_this.onSocketHeartbeat, HEARTBEAT_INTERVAL);
    });

    _defineProperty(_assertThisInitialized(_this), "onSocketClosed", function () {
      log('Socket closed');
      clearTimeout(_this.pingTimeout);
      clearTimeout(_this.heartbeatTimeout);
    });

    _defineProperty(_assertThisInitialized(_this), "onShareDBMessage", function (message) {
      clearTimeout(_this.pingTimeout);
      clearTimeout(_this.heartbeatTimeout);
      _this.pingTimeout = setTimeout(_this.onSocketHeartbeat, HEARTBEAT_INTERVAL); // Message was a response of a ping request, we don't want to process any
      // further. Deleting data branch stops ShareDB's connection to continue

      if (message.data.a === 'ping') {
        delete message.data;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onShareDBConnected", function () {
      log('ShareDB connected');
      clearTimeout(_this.disconnectTimeout);

      _this.props.onConnectionChange('CONNECTED');
    });

    _defineProperty(_assertThisInitialized(_this), "onShareDBConnecting", function () {
      log('ShareDB reconnecting');

      _this.props.onConnectionChange('RECONNECTING');
    });

    _defineProperty(_assertThisInitialized(_this), "onShareDBDisconnected", function () {
      log('ShareDB disconnected, waiting for reconnections');
      _this.disconnectTimeout = setTimeout(function () {
        log('ShareDB did not reconnect on time');

        _this.props.onConnectionChange('DISCONNECTED');
      }, ACCEPTABLE_RECONNECTION_DELAY);
    });

    _this.socket = new RWS(_this.getCollabUrl, null, SOCKET_OPTIONS);

    _this.socket.addEventListener('open', _this.onSocketOpened);

    _this.socket.addEventListener('close', _this.onSocketClosed);

    _this.connection = new ShareDB.Connection(_this.socket);

    _this.connection.on('receive', _this.onShareDBMessage);

    _this.connection.on('connected', _this.onShareDBConnected);

    _this.connection.on('connecting', _this.onShareDBConnecting);

    _this.connection.on('disconnected', _this.onShareDBDisconnected);

    _this.safeAppClose = new SafeAppCloseHelper(function () {
      return !_this.connection.hasWritePending();
    });
    _this.state = {
      connection: _this.connection
    };
    return _this;
  }

  _createClass(CollabConnectionProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.safeAppClose.register();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.disconnectTimeout);
      clearTimeout(this.pingTimeout);
      clearTimeout(this.heartbeatTimeout);
      this.safeAppClose.unregister();
      this.connection.removeAllListeners();
      this.connection.close();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(CollabConnectionContext.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return CollabConnectionProvider;
}(Component);

_defineProperty(CollabConnectionProvider, "propTypes", {
  collabEndpoint: PropTypes.string.isRequired,
  apiToken: PropTypes.string,
  onConnectionChange: PropTypes.func,
  children: PropTypes.any
});

export { CollabConnectionProvider as default };